import { useRouter } from "next/router";
import { useState, useEffect } from "react";

import { getRef } from "lib/firebase";
import { getDoc } from "firebase/firestore";
import { convertDate } from "lib/utils";
import { deltaToHtml } from "lib/deltaToHtml";

import { Article, CurrentUser } from "lib/type";

type Props = {
  article: Article<string>;
};

export const useClientFetchArticle = (props: Props, user: CurrentUser) => {
  const [article, setArticle] = useState(props.article);

  const router = useRouter();
  const isReady = router.isReady;
  useEffect(() => {
    if (!isReady || !user || user.uid !== props.article.author?.uid) return;

    const loadArticle = async () => {
      const { articleID } = router.query;
      if (!articleID || typeof articleID !== "string") return;
      const articleRef = getRef(
        "users",
        `${user.uid}/publicArticles/${articleID}`
      );
      const articleDoc = await getDoc(articleRef).catch((err) => {
        console.log(err);
        alert("記事情報の取得に失敗しました。");
        return null;
      });
      if (!articleDoc || !articleDoc.exists()) return;
      const articleDataRaw = articleDoc.data();
      const {
        thumb,
        color,
        title,
        tags,
        body,
        createdAt,
        updateAt,
        likeCount,
        commentCount,
      } = articleDataRaw;
      const html = deltaToHtml(body);
      const crateDate = convertDate(createdAt);
      const updateDate = updateAt ? convertDate(updateAt) : "";
      const articleData = {
        author: user,
        articleID: articleID,
        thumb: thumb,
        color: color,
        title: title,
        tags: tags,
        body: html,
        createdAt: crateDate,
        updateAt: updateDate,
        likeCount: likeCount,
        commentCount: commentCount,
      };
      setArticle(articleData);
    };
    loadArticle();
  }, [isReady, props.article.author?.uid, router.query, user]);

  return { article };
};
